import { render, staticRenderFns } from "./UsersItem.vue?vue&type=template&id=7a03f747&scoped=true"
import script from "./UsersItem.vue?vue&type=script&lang=js"
export * from "./UsersItem.vue?vue&type=script&lang=js"
import style0 from "./UsersItem.vue?vue&type=style&index=0&id=7a03f747&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a03f747",
  null
  
)

export default component.exports